import React, { useContext, useState } from "react";
import useT from "../../hooks/useT";
import AppFrame from "../../components/AppFrame";
import Page from "../../components/Page";
import CustomersTable from "../../components/CustomersTable";
import LoadingScreen from "../../components/LoadingScreen";
import AppLanguageSwitcher from "../AppLanguageSwitcher";
import AppLayoutHeaderLeftCancel from "../AppLayout/AppLayoutHeaderLeftCancel";
import { ExistingCustomerDataStateObject } from "../../hooks/useCustomerDataState";
import { AppStateContext } from "../App";
import api from "../../utils/api";
import debug from "../../utils/debug";
import { getConfigValue } from "../../config";

export function AppHeaderRightContent() {
  return <AppLanguageSwitcher />;
}

export default function HistoryPage() {
  const { t } = useT();
  const [called, setCalled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [noResults, setNoResults] = useState<boolean>(false);
  const [customers, setCustomers] = useState<
    ExistingCustomerDataStateObject[]
  >();
  const [appState] = useContext(AppStateContext);

  const columns = getConfigValue(
    appState.zone,
    "customise.history.resultsFields"
  );
  const detailsColumns =
    getConfigValue(appState.zone, "customise.history.detailsColumns") ||
    columns;
  const enableEdit = getConfigValue(
    appState.zone,
    "customise.history.enableEdit"
  );

  if (!called) {
    setIsLoading(true);
    setNoResults(false);
    api
      .getCustomersHistory()
      .then((results: any[]) => {
        debug("[historyPage] results:", results);
        setIsLoading(false);
        if (results && results.length) {
          setCustomers(results);
        } else {
          setCustomers([]);
          setNoResults(true);
        }
      })
      .catch(error => {
        debug("[historyPage] error:", error);
        setIsLoading(false);
        setNoResults(true);
      });
    setCalled(true);
  }

  return (
    <AppFrame
      headerLeftContent={
        <AppLayoutHeaderLeftCancel label="general.buttons.back.label" />
      }
      headerRightContent={<AppHeaderRightContent />}
    >
      <Page name="history">
        {(customers && customers.length && (
          <CustomersTable
            customers={customers}
            columns={columns}
            detailsColumns={detailsColumns}
            enableEdit={enableEdit}
          />
        )) ||
          ""}
        {noResults && <span>{t("actions.searchCustomer.noResults")}</span>}
        {isLoading && <LoadingScreen />}
      </Page>
    </AppFrame>
  );
}
